import { useId, type ReactNode } from 'react';

import { cn } from '@eliadmin/core/src/utils/style-utils';

/**
 * Figma account card (e.g. „Osobné údaje“ 60321:19141): white, 1 px border/subtle, radius 18,
 * 24 px padding (16 on phones), DLZ/Heading/H4 title with an optional element on its right, 16 px
 * between the title and the content.
 */
export function AccountCard({
  title,
  aside,
  className,
  children,
}: {
  title?: ReactNode;
  /** Right side of the title row (Figma „Account type“, „Upraviť košík“ …). */
  aside?: ReactNode;
  className?: string;
  children: ReactNode;
}) {
  const titleId = useId();

  return (
    <section
      aria-labelledby={title ? titleId : undefined}
      className={cn(
        'flex flex-col gap-4 rounded-[18px] border border-[#E2E4E7] bg-white p-4 md:p-6',
        className,
      )}
    >
      {title ? (
        <header className="flex items-center gap-3">
          <h2 id={titleId} className="dlz-h4 min-w-0 flex-1 text-[#0F1012]">
            {title}
          </h2>
          {aside}
        </header>
      ) : null}
      {children}
    </section>
  );
}
